const TWITTER_CLICK_ID_PARAM = 'twclid';
const TWITTER_CLICK_ID_COOKIE_DAYS = 90;

const readCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || undefined;
  }
  return undefined;
};

const writeCookie = (name: string, value: string, days: number) => {
  if (typeof document === 'undefined') {
    return;
  }
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};

/**
 * X ads append `twclid` on the landing URL. Signup and Google sign-in rebuild
 * that URL without it, so persist a first-party cookie as soon as we see it.
 */
export const persistTwitterClickId = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const fromQuery = new URLSearchParams(window.location.search).get(
    TWITTER_CLICK_ID_PARAM,
  );
  const fromCookie = readCookie(TWITTER_CLICK_ID_PARAM);
  const twitterClickId = fromQuery || fromCookie || undefined;
  if (!twitterClickId) {
    return undefined;
  }
  if (fromQuery) {
    writeCookie(
      TWITTER_CLICK_ID_PARAM,
      twitterClickId,
      TWITTER_CLICK_ID_COOKIE_DAYS,
    );
  }
  return twitterClickId;
};
